<template>
  <q-form
    autocomplete="off"
  >
    <q-field
      v-if="!!phone"
      :bottom-slots="error"
      :error="error"
      :error-message="errorMessage"
      :color="color"
      :outlined="outline"
      :disable="disable"
      :hint="hint"
      :dense="dense"
      :borderless="borderless"
      class="borderless-children"
      :dark="dark"
      :filled="filled"
      v-bind="$attrs"
      @focus="onFocus"
      @blur="onBlur"
    >
      <div class="flex full-width">
        <q-input
          v-model="phone.country_code"
          borderless
          dense
          stack-label
          label="Country"
          :disable="disable"
          :readonly="readonly"
          prefix="+"
          type="number"
          min="0"
          class="hideable-field"
          :class="{'visible': showCountryArea}"
          tabindex="-1"
          :color="error ? 'negative' : color"
          @keyup.enter="$refs.areaField.focus()"
        />
        <q-input
          ref="areaField"
          v-model="phone.area_code"
          borderless
          dense
          stack-label
          label="Area"
          :disable="disable"
          :readonly="readonly"
          type="number"
          min="0"
          class="hideable-field"
          :class="{'visible': showCountryArea}"
          tabindex="-1"
          :color="error ? 'negative' : color"
          @keyup.enter="focus"
        />
        <q-input
          ref="phoneField"
          v-model="phone.phone_number"
          borderless
          dense
          :stack-label="stackLabel"
          :label="label || 'Phone Number'"
          :disable="disable"
          :readonly="readonly"
          :class="{'required-astrx-container': required}"
          style="flex: 1 0 auto; width: 0px;"
          :color="error ? 'negative' : color"
          :clearable="clearable"
          @clear="$emit('clear')"
        >
          <template v-if="$slots.append" #append>
            <slot name="append" />
          </template>
        </q-input>
      </div>
      <template v-if="$slots.prepend" #prepend>
        <slot name="prepend" />
      </template>
    </q-field>

    <slot
      v-else
      name="blank-button"
      v-bind="{ create: createNewObj }"
    >
      <q-field
        borderless
        dense
        class="borderless-children"
        :error="error"
        :error-message="errorMessage"
        :color="color"
        v-bind="$attrs"
      >
        <div>
          <q-btn
            :disable="disable || readonly"
            :color="!!error ? 'red-8' : color"
            icon="mdi-plus"
            label="Create Phone"
            size="12px"
            @click="createNewObj"
          />
        </div>
      </q-field>
    </slot>
  </q-form>
</template>

<script>
/**
 * PhoneNumber acts similar to default QInput component, including props
 *
 * SLOTS:
 * - append: content to appear within field at the right
 * - prepend: content to appear within field at the left
 * - buttons: content to display below the phone number field
 * - blank-button: (create) - if phone prop is null, display default button to create new phone object
 */
export default {
  inheritAttrs: false,
  props: {
    phone: {
      type: Object,
      default: null
    },
    error: {
      default: false,
      type: Boolean
    },
    errorMessage: {
      type: String,
      default: 'This phone number is invalid'
    },
    disable: {
      default: false,
      type: Boolean
    },
    color: {
      default: 'primary',
      type: String
    },
    readonly: {
      default: false,
      type: Boolean
    },
    required: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String
    },
    borderless: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    dark: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    stackLabel: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  emits: ['clear', 'create'],
  data () {
    return {
      focused: false
    }
  },
  computed: {
    showCountryArea () {
      return this.focused || ((this.phone.area_code && this.phone.area_code.length) > 0 || (this.phone.country_code && this.phone.country_code.length))
    }
  },
  methods: {
    createNewObj () {
      if (this.phone) {
        return
      }
      this.$emit('create')
    },
    onFocus () {
      this.focused = true
    },
    onBlur () {
      this.focused = false
    },
    focus () {
      this.$refs.phoneField.focus()
    }
  }
}
</script>

<style scoped lang="scss">
.hideable-field {
  transition: width 0.25s ease, opacity 0.25s ease;
  width: 0px;
  opacity: 0;
  visibility: hidden;

  &.visible {
    opacity: 1 !important;
    width: 50px !important;
    visibility: visible !important;
  }
}
</style>
